<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg8 offset-lg2>
      <v-container fluid>
        <v-tabs
          fixed
          icons
          centered
        >
          <v-tab href="#personal">
            <v-icon>account_box</v-icon>
            <span class="hidden-sm-and-down">{{ $t('newUser.STEP_PERSONAL') }}</span>
          </v-tab>
          <v-tab href="#school" :disabled="isExpert">
            <v-icon>account_balance</v-icon>
            <span class="hidden-sm-and-down">{{ $t('newUser.STEP_SCHOOL') }}</span>
          </v-tab>
          <v-tabs-items>
            <v-tab-item
              key="1"
              id="personal"
            >
              <v-card flat>
                <v-card-title>
                  <h3>Usuari {{ $route.params.userId }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn v-if="!user.registered" @click.native.stop="dialogSendMail = true"><v-icon>send</v-icon></v-btn>
                  <v-btn v-if="user.enabled" color="error" @click.native.stop="dialogDelete = true"><v-icon light>lock</v-icon></v-btn>
                  <v-btn v-if="!user.enabled" color="success" @click.native.stop="dialogEnable = true"><v-icon>lock_open</v-icon></v-btn>
                </v-card-title>
                <v-layout wrap>
                  <v-flex class="mt-2" xs8 offset-xs2>
                    <v-text-field
                      :label="$t('user.NAME')"
                      v-model="user.name"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-text-field
                      :label="$t('user.SURNAME_1')"
                      v-model="user.surname1"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-text-field
                      :label="$t('user.SURNAME_2')"
                      v-model="user.surname2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-text-field
                      :label="$t('user.USERNAME')"
                      v-model="user.username"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-select
                      v-bind:items="roles"
                      item-text="name"
                      item-value="id"
                      v-model="user.roleId"
                      :label="$t('user.USER_TYPE')"
                      required
                    >
                      <template slot="selection" slot-scope="data">{{ $t('role.'+data.item.name) }}</template>
                      <template slot="item" slot-scope="data">{{ $t('role.'+data.item.name) }}</template>
                    </v-select>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-select
                      v-bind:items="languages"
                      item-text="shortname"
                      item-value="id"
                      v-model="user.defaultLanguageId"
                      :label="$t('user.LANGUAGE')"
                      required
                    >
                      <template slot="selection" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                      <template slot="item" slot-scope="data">{{ $t('language.'+data.item.shortname) }}</template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
            <v-tab-item
              key="2"
              id="school"
            >
              <v-card flat>
                <v-layout wrap>
                  <v-flex xs8 class="mt-2" offset-xs2>
                    <v-select
                      v-bind:items="schools"
                      item-text="name"
                      item-value="id"
                      v-model="user.schoolId"
                      :label="$t('newUser.SCHOOL_NAME')"
                      required
                    >
                      <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
                      <template slot="item" slot-scope="data">{{ data.item.name }}</template>
                    </v-select>
                  </v-flex>
                  <v-flex xs8 class="mt-2" offset-xs2>
                    <v-text-field
                      :label="$t('newUser.GRADO_MASTER')"
                      v-model="user.degree"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-text-field
                      :label="$t('newUser.COURSE')"
                      v-model="user.course"
                      required></v-text-field>
                  </v-flex>
                  <v-flex xs8 offset-xs2>
                    <v-combobox
                      v-model="user.subjects"
                      :label="$t('newUser.SUBJECTS')"
                      :hint="$t('newUser.SUBJECTS_HINT')"
                      persistent-hint
                      append-icon=""
                      hide-no-data
                      deletable-chips
                      multiple
                      chips
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs8 offset-xs2 mt-2>
                    <v-text-field
                      :label="$t('newUser.STUDENTS_NUMBER')"
                      v-model="user.studentsNumber"
                      type="number"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-container>
    </v-flex>
    <v-btn fab large bottom right fixed color="success" @click.native="submit" :disabled="!canSaveUser"><v-icon>save</v-icon></v-btn>
    <v-layout row justify-center>
      <v-dialog v-model="dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline">{{ $t('dialogs.deleteUser.HEADER') }}</v-card-title>
          <v-card-text>{{ $t('dialogs.deleteUser.MESSAGE') }}</v-card-text>
          <v-card-actions>
            <v-btn class="green--text darken-1" flat="flat" @click.native="dialogDelete = false">{{ $t('dialogs.deleteUser.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="red white--text darken-1" flat="flat" @click.native="deleteUser">{{ $t('dialogs.deleteUser.OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEnable" persistent>
        <v-card>
          <v-card-title class="headline">{{ $t('dialogs.enableUser.HEADER') }}</v-card-title>
          <v-card-text>{{ $t('dialogs.enableUser.MESSAGE') }}</v-card-text>
          <v-card-actions>
            <v-btn flat @click.native="dialogEnable = false">{{ $t('dialogs.enableUser.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="success" @click.native="enableUser">{{ $t('dialogs.enableUser.OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="dialogSendMail" persistent>
        <v-card>
          <v-card-title class="headline">{{ $t('dialogs.sendMail.HEADER') }}</v-card-title>
          <v-card-text>{{ $t('dialogs.sendMail.MESSAGE') }}</v-card-text>
          <v-card-actions>
            <v-btn class="red white--text darken-1" flat="flat" @click.native="dialogSendMail = false">{{ $t('dialogs.sendMail.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="green--text darken-1" flat="flat" @click.native="sendMail">{{ $t('dialogs.sendMail.OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<style>
.tabs__wrapper {
  overflow-x: inherit;
}
</style>

<script>
import {UserResource} from '../../api/user'
import {SchoolResource} from '../../api/school'
import {LanguageResource} from '../../api/language'
import {RoleResource} from '../../api/role'

export default {
  name: 'user',
  data () {
    return {
      user: {
        name: '',
        surname1: '',
        surname2: '',
        username: '',
        roleId: '',
        schoolId: '',
        degree: '',
        course: '',
        studentsNumber: '',
        defaultLanguageId: '',
        enabled: '',
        subjects: []
      },
      languages: [],
      roles: [],
      schools: [],
      dialogDelete: false,
      dialogEnable: false,
      dialogSendMail: false
    }
  },
  created: function () {
    LanguageResource().get().then(
      response => {
        this.languages = response.data
      },
      response => {
        console.log('error')
      }
    )
    SchoolResource().get().then(
      response => {
        this.schools = response.data
      },
      response => {
        console.log('error in schools endpoint')
      }
    )
    RoleResource().get().then(
      response => {
        this.roles = response.data
      },
      response => {
        console.log('error in roles endpoint')
      }
    )
    UserResource().get({id: this.$route.params.userId}).then(response => {
      this.user = response.body
      console.log(this.user)
    }, response => {
      this.$emit('showSnackbar', response.body.message)
      this.$router.push({ name: 'Users' })
    })
  },
  computed: {
    isExpert: function () {
      return (this.user.roleId !== '' && this.findItemById(this.roles, this.user.roleId).name === 'EXPERT')
    },
    isTeacher: function () {
      return (this.user.roleId !== '' && this.findItemById(this.roles, this.user.roleId).name === 'TEACHER')
    },
    basicInfoIntroduced: function () {
      return (this.user.defaultLanguageId > 0 &&
        this.user.username !== '')
    },
    teacherInfoIntroduced: function () {
      return (this.user.schoolId > 0 && this.user.degree !== '' && this.user.course !== '' && this.user.studentsNumber > 0)
    },
    canSaveTeacher: function () {
      return (this.isTeacher &&
        this.basicInfoIntroduced &&
        this.teacherInfoIntroduced)
    },
    canSaveExpert: function () {
      return (this.isExpert &&
        this.basicInfoIntroduced)
    },
    canSaveUser: function () {
      console.log('expert: ' + this.isExpert)
      return this.canSaveTeacher || this.canSaveExpert
    }
  },
  methods: {
    submit: function () {
      UserResource().update({id: this.$route.params.userId}, this.user).then(response => {
        console.log(response)
        this.$router.push({ name: 'Users' })
      }, response => {
        this.$emit('showSnackbar', response.body.message)
        console.log(response)
      })
    },
    deleteUser: function () {
      UserResource().remove({id: this.$route.params.userId}).then(response => {
        this.dialogDelete = false
        this.$router.push({ name: 'Users' })
      }, response => {
        console.log(response)
      })
    },
    enableUser: function () {
      UserResource().enable({id: this.$route.params.userId}, {item: ''}).then(response => {
        this.dialogEnable = false
        this.$router.push({ name: 'Users' })
      }, response => {
        console.log(response)
      })
    },
    sendMail: function () {
      UserResource().sendMail({id: this.$route.params.userId}, {item: ''}).then(response => {
        this.dialogSendMail = false
        this.$router.push({ name: 'Users' })
      }, response => {
        console.log(response)
      })
    },
    findItemById: function (collection, itemId) {
      return this._.find(collection, function (i) {
        return i.id === itemId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/User.vue